import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { MainService } from 'src/app/services/main/main.service';
import { Router } from '@angular/router';
// import { Intercom } from 'ng-intercom';
import { AuthService } from 'src/app/services/auth/auth.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { GlobalFilterService } from 'src/app/services/shared/global-filter.service';
declare var Intercom: any;

@Component({
  selector: 'app-logout-dialog',
  templateUrl: 'logout.component.html',
  styleUrls: ['./logout.component.scss']

})
export class LogoutComponentDialog {

  constructor(
    public dialogRef: MatDialogRef<LogoutComponentDialog>,
    // public intercom: Intercom,
    private mainService: MainService,
    public authService: AuthService,
    private router: Router,
    private _shared: SharedService,
    private globalFilterService: GlobalFilterService
    ) {}

    logout() {
      localStorage.removeItem('environment');

      const data = {
        access_token: localStorage.getItem('token'),
        device_type: environment.device_type,
        app_type: environment.app_type,
        app_version: environment.app_version,
        device_token: environment.device_token,
        device_id: localStorage.getItem('user')
      };
      // const data = this.urlParams(formData);
      this.mainService.api(data, `logout`, true, 'object')
        .subscribe(_data => {
          this.mainService.notification_list = [];
          this.mainService.unread_count = 0;
          this.mainService.clearPFData();
          this.mainService.store.reset();
          localStorage.removeItem('token');
          localStorage.removeItem('environment');
          localStorage.removeItem('userProfileData');
          localStorage.removeItem('timezone');
          // localStorage.removeItem('baseUrl');
          localStorage.removeItem('recurring_extra_amount');
          localStorage.removeItem('fixed_flat_fee');
          localStorage.removeItem('locations');
          localStorage.removeItem('departments');
          localStorage.removeItem('roleId');
          localStorage.removeItem('ppViewMode');
          localStorage.removeItem('arViewMode');
          localStorage.removeItem('viewMode');
          sessionStorage.removeItem('globalFilter');
          localStorage.removeItem('reset_email');
          localStorage.removeItem('doctorToken');
          localStorage.removeItem('getFinanceValues');
          localStorage.removeItem('currentLoc');
          localStorage.removeItem('doctorProfile');
          localStorage.removeItem('doctorSettings');
          localStorage.removeItem('validateInputData');
          localStorage.removeItem('subscription_data');
          localStorage.removeItem('currentScrren');
          localStorage.removeItem('show_ar_popup');
          localStorage.removeItem('hideTopBar');
          localStorage.removeItem('globalFilter');
          localStorage.removeItem('locations');

          this._shared.clearLocalStorage();
          this.globalFilterService.clearGlobalFilter()
          this.dialogRef.close();
          // this.intercom.shutdown();
          Intercom('shutdown');
          this.router.navigate(['login']);
          this.authService.showIntercomIcon = false;
        });
    }

}


